import styled from "styled-components";
import TuneIcon from "@mui/icons-material/Tune";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexColumnDiv } from "./common.styles";
import { MobileTextField } from "./HXMobilePage.styles";
import { FilterToggleButton } from "./FastenUI.styles";
export const SearchTipsSection = styled(FlexColumnDiv) `
    gap: 8px;
    flex-shrink: 0;
`;
export const SearchTipsList = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const SearchTipItem = styled(FlexColumnDiv) `
    gap: 4px;
    padding: 12px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
`;
export const SearchTipItemTitle = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.navy_main};
`;
export const SearchTipItemDescription = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
`;
export const PatientPortalFilterIcon = styled(TuneIcon) `
    font-size: 24px !important;
    color: ${colors.navy_main};
`;
export const PatientPortalSearchInput = styled(MobileTextField) `
    width: 100%;

    & .MuiInputBase-input::placeholder,
    & .MuiInputBase-input:placeholder-shown {
        color: ${colors.black_lighter};
        opacity: 1;
    }
`;
export const PatientPortalFilterToggleButton = styled(FilterToggleButton) `
    box-sizing: border-box;
`;
export const ContentArea = styled(FlexColumnDiv) `
    position: relative;
    flex: 1;
    min-height: 0;
    width: 100%;
`;
export const FilterOverlay = styled(FlexColumnDiv) `
    position: absolute;
    inset: 0;
    z-index: 1;
    background-color: ${colors.white_main};
    overflow-y: auto;
`;
export const NoResultsContainer = styled(FlexColumnDiv) `
    align-items: center;
    gap: 24px;
    padding: 24px 0 16px;
    flex-shrink: 0;
`;
export const NoResultsIconCircle = styled.div `
    width: 51px;
    height: 51px;
    border-radius: 50%;
    background-color: ${colors.blue_10};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.navy_main};
    flex-shrink: 0;

    svg {
        font-size: 24px;
    }
`;
export const NoResultsTextContainer = styled(FlexColumnDiv) `
    align-items: center;
    gap: 2px;
    width: 100%;
`;
export const NoResultsHeading = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    text-align: center;
    word-break: break-word;
`;
export const NoResultsSubheading = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    text-align: center;
`;
export const NoResultsReasonsList = styled(FlexColumnDiv) `
    gap: 7px;
    width: 100%;
`;
export const NoResultsReasonItem = styled(FlexColumnDiv) `
    gap: 4px;
    padding: 12px 20px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
`;
export const NoResultsReasonTitle = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.navy_main};
`;
export const NoResultsReasonDescription = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    line-height: 1.4;
`;
export const NoResultsRequestButtonContainer = styled.div `
    display: flex;
    justify-content: center;
    padding: 16px 0 8px;
    width: 100%;
    flex-shrink: 0;

    > button {
        width: 100%;
        max-width: 400px;
        border-radius: 999px;
        height: 56px;
    }
`;
